import React from 'react';
import { FileText, Zap, Baby, ShieldCheck, Lock, CreditCard } from 'lucide-react';
import { Button } from './Shared';
export const Hero = () => {
  return <section className="relative px-4 overflow-hidden py-8 md:py-12 pt-[10px] pb-[10px]" data-id="element-141">
      {/* Decorative stars */}
      <div className="absolute top-20 left-10 w-2 h-2 bg-gold-400 rounded-full opacity-50 blur-[1px]" data-id="element-142"></div>
      <div className="absolute top-40 right-20 w-3 h-3 bg-gold-400 rounded-full opacity-30 blur-[2px]" data-id="element-143"></div>

      <div className="max-w-6xl mx-auto text-center" data-id="element-144">
        <div className="inline-flex items-center space-x-2 text-gold-400 font-serif font-semibold tracking-wider uppercase text-xs mb-4" data-id="element-145">
          <span className="w-8 h-[1px] bg-gold-400" data-id="element-146"></span>
          <span data-id="element-147">MUNDO PRÁCTICO™</span>
          <span className="w-8 h-[1px] bg-gold-400" data-id="element-148"></span>
        </div>

        <h1 className="text-3xl md:text-5xl lg:text-6xl font-serif font-bold text-white mb-3 leading-[1.1] break-words" data-id="element-149">
          Todo lo que tu bebé <br className="hidden md:block" data-id="element-150" />
          necesita para dormir.
        </h1>
        <p className="text-lg md:text-2xl font-serif italic text-gold-400 mb-6" data-id="element-151">
          Listo. Desde esta noche.
        </p>

        <div className="relative max-w-2xl mx-auto px-4 mt-[14px] mb-[14px]" data-id="element-152">
          <div className="absolute inset-0 bg-[radial-gradient(circle,rgba(234,179,8,0.15)_0%,transparent_70%)] rounded-full" data-id="element-153"></div>
          <picture data-id="element-154">
            <source type="image/webp" srcSet="https://cdn.magicpatterns.com/uploads/11ZX5XvyjAt9GbyuWdPbFL/MockUp-Noches-de-Paz-_1__(2)_(1).webp?w=400 400w, https://cdn.magicpatterns.com/uploads/11ZX5XvyjAt9GbyuWdPbFL/MockUp-Noches-de-Paz-_1__(2)_(1).webp?w=800 800w, https://cdn.magicpatterns.com/uploads/11ZX5XvyjAt9GbyuWdPbFL/MockUp-Noches-de-Paz-_1__(2)_(1).webp 1080w" sizes="(max-width: 768px) 90vw, 600px" data-id="element-155" />
            <img src="https://cdn.magicpatterns.com/uploads/11ZX5XvyjAt9GbyuWdPbFL/MockUp-Noches-de-Paz-_1__(2)_(1).webp" srcSet="https://cdn.magicpatterns.com/uploads/11ZX5XvyjAt9GbyuWdPbFL/MockUp-Noches-de-Paz-_1__(2)_(1).webp?w=400 400w, https://cdn.magicpatterns.com/uploads/11ZX5XvyjAt9GbyuWdPbFL/MockUp-Noches-de-Paz-_1__(2)_(1).webp?w=800 800w, https://cdn.magicpatterns.com/uploads/11ZX5XvyjAt9GbyuWdPbFL/MockUp-Noches-de-Paz-_1__(2)_(1).webp 1080w" sizes="(max-width: 768px) 90vw, 600px" alt="MegaPack Noches de Paz" className="relative z-10 w-full h-auto drop-shadow-2xl mt-[14px] mb-[14px]" width={1080} height={1080} loading="eager" fetchPriority="high" decoding="sync" data-id="element-156" />
          </picture>
        </div>

        <p className="text-sm text-gray-200 mt-[14px] mb-[14px]" data-id="element-157">
          El sistema N°1 para padres con bebés en Argentina — 0 a 36 meses
        </p>
        <p className="text-sm text-gray-100 max-w-2xl mx-auto mt-[14px] mb-[14px]" data-id="element-158">
          Sin improvisar. Sin buscar. Sin más madrugadas sin saber qué hacer.
        </p>

        <div className="flex flex-nowrap justify-center gap-2 sm:gap-4 md:gap-8 text-gray-100 px-2 mt-[16px] mb-[16px]" data-id="element-159">
          <div className="flex items-center text-[9px] sm:text-xs md:text-sm whitespace-nowrap shrink-0" data-id="element-160">
            <FileText className="w-3 h-3 md:w-4 md:h-4 mr-1 md:mr-1.5 text-gold-400" data-id="element-161" />{' '}
            100% PDF
          </div>
          <div className="flex items-center text-[9px] sm:text-xs md:text-sm whitespace-nowrap shrink-0" data-id="element-162">
            <Zap className="w-3 h-3 md:w-4 md:h-4 mr-1 md:mr-1.5 text-gold-400" data-id="element-163" />{' '}
            Acceso en 5 min
          </div>
          <div className="flex items-center text-[9px] sm:text-xs md:text-sm whitespace-nowrap shrink-0" data-id="element-164">
            <Baby className="w-3 h-3 md:w-4 md:h-4 mr-1 md:mr-1.5 text-gold-400" data-id="element-165" />{' '}
            0 a 36 meses
          </div>
          <div className="flex items-center text-[9px] sm:text-xs md:text-sm whitespace-nowrap shrink-0" data-id="element-166">
            <ShieldCheck className="w-3 h-3 md:w-4 md:h-4 mr-1 md:mr-1.5 text-gold-400" data-id="element-167" />{' '}
            Garantía 7 días
          </div>
        </div>

        <Button href="#plan-premium" className="mb-6 w-full md:w-auto text-base md:text-xl px-6 md:px-10 py-4 md:py-5" data-id="element-168">
          🌙 → QUIERO MI MEGAPACK AHORA
        </Button>
        <div className="flex items-center justify-center space-x-4 text-sm text-gray-200 mb-8" data-id="element-169">
          <span className="flex items-center" data-id="element-170">
            <Lock className="w-4 h-4 mr-1" data-id="element-171" /> Pago seguro
          </span>
          <span data-id="element-172">|</span>
          <span className="flex items-center" data-id="element-173">
            <CreditCard className="w-4 h-4 mr-1" data-id="element-174" /> Mercado Pago
          </span>
        </div>
      </div>
    </section>;
};